import { render, staticRenderFns } from "./BookingsHome.vue?vue&type=template&id=38d6e0ff"
import script from "./BookingsHome.vue?vue&type=script&lang=js"
export * from "./BookingsHome.vue?vue&type=script&lang=js"
import style0 from "./BookingsHome.vue?vue&type=style&index=0&id=38d6e0ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports